module.exports = __webpack_public_path__ + "static/media/signage-indoor-img70.a402e66b.jpg";